/* Дундын тогтмолууд — өгөгдөл нь бүгд server-ээс (mock хасагдсан) */
import type { LucideIcon } from './icons';
import {
  IconCar, IconJeep, IconTruck, IconBus,
  IconLayout, IconUsers, IconChart, IconClock, IconSettings,
  IconPlay, IconCheck, IconBanknote,
} from './icons';
import type { CarStatus, CarType, NavKey } from './types';

/* Backend CwCarType int ↔ UI label */
export const CAR_TYPE_LABELS: CarType[] = ['Суудлын', 'Жийп', 'Том оврын', 'Микроавтобус'];

export function carTypeLabel(v: number): CarType {
  return CAR_TYPE_LABELS[v] ?? 'Суудлын';
}

export function carTypeInt(label: CarType): number {
  const i = CAR_TYPE_LABELS.indexOf(label);
  return i < 0 ? 0 : i;
}

export const CAR_TYPES: Record<CarType, LucideIcon> = {
  'Суудлын': IconCar,
  'Жийп': IconJeep,
  'Том оврын': IconTruck,
  'Микроавтобус': IconBus,
};

/* Backend CwOrderStatus int ↔ UI status (Paid/Cancelled самбарт ирэхгүй) */
export function statusFromInt(v: number): CarStatus {
  return v === 1 ? 'washing' : v === 2 ? 'done' : 'waiting';
}

export interface StatusMeta {
  label: string;
  short: string;
  dot: string;
  action: string;
  ActionIcon: LucideIcon;
}

export const STATUS_META: Record<CarStatus, StatusMeta> = {
  waiting: { label: 'Хүлээж буй',  short: 'Хүлээж буй', dot: 'bg-amber-400',   action: 'Угааж эхлэх', ActionIcon: IconPlay },
  washing: { label: 'Угааж буй',   short: 'Угааж буй',  dot: 'bg-cyan-500',    action: 'Дуусгах',     ActionIcon: IconCheck },
  done:    { label: 'Дууссан · Төлбөр хүлээж буй', short: 'Дууссан', dot: 'bg-emerald-500', action: 'Төлбөр авах', ActionIcon: IconBanknote },
};
export const STATUS_ORDER: CarStatus[] = ['waiting', 'washing', 'done'];

export const NAV: { key: NavKey; label: string; Icon: LucideIcon }[] = [
  { key: 'queue',     label: 'Дараалал',  Icon: IconLayout },
  { key: 'customers', label: 'Харилцагч', Icon: IconUsers },
  { key: 'reports',   label: 'Тайлан',    Icon: IconChart },
  { key: 'shift',     label: 'Ээлж',      Icon: IconClock },
  { key: 'settings',  label: 'Тохиргоо',  Icon: IconSettings },
];

/* 10 угаалга тутамд 1 үнэгүй */
export const LOYALTY_GOAL = 10;
